<span class="flex items-center h-full" [ngClass]="visibleIcon()?.color">
    @if (animateLoading()) {
        <div class="icon-wrapper">
            <i [matTooltip]="tooltipText()" matTooltipClass="multiline-tooltip" class="custom-spinner"></i>
        </div>
    } @else {
        @if (visibleIcon()?.onClick) {
            <!-- NOSONAR -->
            <mat-icon 
                (click)="onClick($event)" 
                class="icon-wrapper clickable" 
                [matTooltip]="tooltipText()" 
                matTooltipClass="multiline-tooltip"
                [matBadge]="badge()"
                [ngClass]="badgeColorClass()">
                {{ visibleIcon()?.icon }}
            </mat-icon>
        } @else {
            <mat-icon class="icon-wrapper " [matTooltip]="tooltipText()" matTooltipClass="multiline-tooltip">{{ visibleIcon()?.icon }}</mat-icon>
        }
    }
</span>
